export const UNIDADES_EDAD = {
  DIAS: "DIAS",
  MESES: "MESES",
  ANIOS: "ANIOS",
};

const FACTOR_A_DIAS = {
  [UNIDADES_EDAD.DIAS]: 1,
  [UNIDADES_EDAD.MESES]: 30,
  [UNIDADES_EDAD.ANIOS]: 365,
};

export function convertirADias(valor, unidad) {
  const numero = Number(valor);
  if (!Number.isFinite(numero) || numero < 0) {
    return null;
  }

  const factor = FACTOR_A_DIAS[unidad] ?? FACTOR_A_DIAS[UNIDADES_EDAD.DIAS];
  return Math.trunc(numero) * factor;
}

const parsearLimiteInversoLegacy = (normalizado, operador) => {
  const op = String(operador || "").trim();
  const offset = op === "<" ? -1 : op === ">" ? 1 : 0;
  if (!offset) return null;

  const base = normalizado + offset;
  if (base < 0) return null;

  if (base % FACTOR_A_DIAS[UNIDADES_EDAD.ANIOS] === 0) {
    return {
      valor: base / FACTOR_A_DIAS[UNIDADES_EDAD.ANIOS] - offset,
      unidad: UNIDADES_EDAD.ANIOS,
    };
  }

  if (base % FACTOR_A_DIAS[UNIDADES_EDAD.MESES] === 0) {
    return {
      valor: base / FACTOR_A_DIAS[UNIDADES_EDAD.MESES] - offset,
      unidad: UNIDADES_EDAD.MESES,
    };
  }

  return null;
};

export function parsearDesdeDias(totalDias, operador) {
  const dias = Number(totalDias);
  if (!Number.isFinite(dias) || dias < 0) {
    return { valor: "", unidad: UNIDADES_EDAD.DIAS };
  }

  const normalizado = Math.trunc(dias);

  if (normalizado % FACTOR_A_DIAS[UNIDADES_EDAD.ANIOS] === 0) {
    return {
      valor: normalizado / FACTOR_A_DIAS[UNIDADES_EDAD.ANIOS],
      unidad: UNIDADES_EDAD.ANIOS,
    };
  }

  if (normalizado % FACTOR_A_DIAS[UNIDADES_EDAD.MESES] === 0) {
    return {
      valor: normalizado / FACTOR_A_DIAS[UNIDADES_EDAD.MESES],
      unidad: UNIDADES_EDAD.MESES,
    };
  }

  const limiteInversoLegacy = parsearLimiteInversoLegacy(normalizado, operador);
  if (limiteInversoLegacy) return limiteInversoLegacy;

  return { valor: normalizado, unidad: UNIDADES_EDAD.DIAS };
}

export function renderCondicionEdad(dias, operador = "<=") {
  const { valor, unidad } = parsearDesdeDias(dias, operador);
  const numero = Number(valor);

  if (!Number.isFinite(numero)) {
    return "Edad";
  }

  const etiquetaUnidad =
    unidad === UNIDADES_EDAD.ANIOS
      ? numero === 1
        ? "Año"
        : "Años"
      : unidad === UNIDADES_EDAD.MESES
      ? numero === 1
        ? "Mes"
        : "Meses"
      : numero === 1
      ? "Dia"
      : "Dias";

  return `Edad ${operador} ${numero} ${etiquetaUnidad}`;
}

export function invertirCondicionNumerica(condicion = {}) {
  const operadorOriginal = String(condicion?.operador || "").trim();
  if (operadorOriginal !== "<" && operadorOriginal !== ">") return { ...condicion };

  const operadorInvertido = operadorOriginal === "<" ? ">" : "<";
  const tipo = String(condicion?.tipo ?? condicion?.atributo ?? "").trim().toLowerCase();

  if (tipo === "edad") {
    const { valor, unidad } = parsearDesdeDias(condicion?.valor);
    const valorNumerico = Number(valor);
    if (!Number.isFinite(valorNumerico)) {
      return { ...condicion, operador: operadorInvertido };
    }

    const valorInvertido = operadorOriginal === "<"
      ? Math.max(0, valorNumerico - 1)
      : valorNumerico + 1;

    return {
      ...condicion,
      operador: operadorInvertido,
      valor: convertirADias(valorInvertido, unidad),
    };
  }

  const valorNumerico = Number(condicion?.valor);
  const esNumerico = String(condicion?.valor ?? "").trim() !== "" && Number.isFinite(valorNumerico);
  const valorInvertido = esNumerico
    ? (operadorOriginal === "<" ? valorNumerico - 1 : valorNumerico + 1)
    : condicion?.valor;

  return { ...condicion, operador: operadorInvertido, valor: valorInvertido };
}


